import './assigned-pmas.scss';
import Header from '../../../organisms/header/header.js';
import RoleRibbonByRole from '../../../organisms/common/role-ribbon/role-ribbon-by-role';
import {Navigate, useLocation, useParams, useNavigate} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import decodeToken from '../../../../utils/decode-token';
import axios from 'axios';
import ModalReassignPma from '../../../organisms/role-admin/modal-reassign-pma/modal-reassign-pma';
import BackButton from '../../../atoms/back-button';
import ModalEditPma from '../../../organisms/role-admin/modal-edit-pma/modal-edit-pma';
import {Alert, Snackbar} from '@mui/material';
import HacNavigation from "../../../organisms/common/hac-navigation/hac-navigation";
import { ROLE_GROUPS, isAuthorizedRole, isRetailerRole } from '../../../../utils/role-utils';

function AssignedPmas() {
  const {t} = useTranslation();
  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;
  const {hacId} = useParams();
  const navigate = useNavigate();
  const [contactInfo, setContactInfo] = useState(null);
  const [modalOpenReassignPma, setModalOpenReassignPma] = useState(false);
  const [currentPma, setCurrentPma] = useState(null);
  const [pmaType, setPmaType] = useState(1);
  const [modalOpenEditPma, setModalOpenEditPma] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const location = useLocation();
  const {breadcrumbName, backPath} = location.state || {};
  const isRetailer = isRetailerRole(role);
  const canEditAssignedPmas = !isRetailer;
  const canAccessAssignedPmas = isAuthorizedRole(role, [
    ...ROLE_GROUPS.admin,
    ...ROLE_GROUPS.retailer,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      const authToken = token;
      const url = `${process.env.REACT_APP_API_URL}/pma/contact-info/hac/${hacId}`;

      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Cache-Control': 'no-cache',
        },
      };

      try {
        const response = await axios.get(url, config);
        if (response.status === 200) {
          setContactInfo(response.data);
        }
      } catch (error) {
        if (error.response) {
          setSnackbarOpen(true);
          setSnackbarMessage(t('common-internal-server-error'), error);
        }
      }
    };

    fetchData();
  }, [hacId, token, t]);

  const openModalReassignPma = (pma, type) => {
    setCurrentPma(pma);
    setPmaType(type);
    setModalOpenReassignPma(true);
  };

  const closeModalReassignPma = () => {
    setModalOpenReassignPma(false);
    setCurrentPma(null);
  };

  const openModalEditPma = (pma) => {
    setCurrentPma(pma);
    setModalOpenEditPma(true);
  };

  const closeModalEditPma = () => {
    setModalOpenEditPma(false);
    setCurrentPma(null);
  };

  return (
    <>
      {token && canAccessAssignedPmas ? (
        <div className="App">
          <Header/>
          <RoleRibbonByRole role={role} navigate={navigate} translate={t} />
          <main>
            <section className="contact-info assigned-pmas">
              <div className="inner menu">

                <HacNavigation/>

                <main className="profile">

                <BackButton
                  fallbackTo={backPath || (isRetailer
                    ? '/retailer/main/active'
                    : '/admin/main/hac?status=active')}
                  context={breadcrumbName}
                />


                  <h2>{t('pma-info-title')}</h2>
                  {contactInfo ? (
                    <>
                      <h5>{t('pma-info-title-pma1')}</h5>
                      <div className="person">
                        <>
                          {contactInfo.first_pma && (
                            <dl>
                              <div>
                                <dt>{t('common-name')}</dt>
                                <dd>
                                  {contactInfo.first_pma.name}{' '}
                                  {contactInfo.first_pma.last_name}
                                </dd>
                              </div>
                              <div>
                                <dt>{t('common-email')}</dt>
                                <dd>{contactInfo.first_pma.email}</dd>
                              </div>
                              <div>
                                <dt>{t('common-phone')}</dt>
                                <dd>
                                  {contactInfo.first_pma.prefix_phone}{' '}
                                  {contactInfo.first_pma.phone}
                                </dd>
                              </div>
                              <div>
                                <dt>{t('common-country')}</dt>
                                <dd>
                                  {t(
                                    `countries-${contactInfo.first_pma.area_code}`
                                  ) || 'N/A'}
                                </dd>
                              </div>
                            </dl>
                          )}
                          <div className="actions">
                            {/*{contactInfo.first_pma && (
                              <button
                                className="btn secondary"
                                onClick={() =>
                                  openModalEditPma(contactInfo.first_pma)
                                }
                              >
                                {t('pma-info-action1')}
                              </button>
                            )}*/}

                            {canEditAssignedPmas && (
                              <button
                                className="btn secondary"
                                onClick={() =>
                                  openModalReassignPma(contactInfo.first_pma, 1)
                                }
                              >
                                {contactInfo.first_pma ? t('pma-info-action2') : t('pma-info-action3')}

                              </button>
                              )
                            }
                          </div>
                        </>
                      </div>

                      {contactInfo.second_pma && (
                    <>
                      <h5>{t('pma-info-title-pma2')}</h5>

                      <div className="person">
                        {contactInfo.second_pma && (
                          <dl>
                            <div>
                              <dt>{t('common-name')}</dt>
                              <dd>
                                {contactInfo.second_pma.name || 'N/A'}{' '}
                                {contactInfo.second_pma.last_name || ''}
                              </dd>
                            </div>

                            <div>
                              <dt>{t('common-email')}</dt>
                              <dd>{contactInfo.second_pma.email || 'N/A'}</dd>
                            </div>

                            <div>
                              <dt>{t('common-phone')}</dt>
                              <dd>
                                {contactInfo.second_pma.prefix_phone || 'N/A'}{' '}
                                {contactInfo.second_pma.phone || ''}
                              </dd>
                            </div>

                            <div>
                              <dt>{t('common-country')}</dt>
                              <dd>
                                {t(`countries-${contactInfo.second_pma.area_code}`) || 'N/A'}
                              </dd>
                            </div>
                          </dl>
                        )}

                        <div className="actions">
                          {canEditAssignedPmas && (
                            <button
                              className="btn secondary"
                              onClick={() =>
                                openModalReassignPma(contactInfo.second_pma, 2)
                              }
                            >
                              {contactInfo.second_pma
                                ? t('pma-info-action2')
                                : t('pma-info-action3')}
                            </button>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                    </>
                  ) : (
                    <div>Loading...</div>
                  )}
                </main>
              </div>
            </section>
          </main>

          {canEditAssignedPmas && (
            <>
              <ModalReassignPma
                open={modalOpenReassignPma}
                onClose={closeModalReassignPma}
                hacId={hacId}
                currentPma={currentPma}
                pmaType={pmaType}
              />

              <ModalEditPma
                open={modalOpenEditPma}
                onClose={closeModalEditPma}
                currentPma={currentPma}
              />
            </>
          )}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={handleSnackbarClose}
          >
            <Alert severity="error" sx={{width: '100%'}}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
      ) : (
        <Navigate to="/login"/>
      )}
    </>
  );
}

export default AssignedPmas;
